<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-07 16:31:55
-->
<template>
  <div class="flex flex-align-center">
    <div :class="['state_icon', stateClass]"></div>
    <div class="ml-10">{{row['audit_status_desc']}}</div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin],
  computed: {
    stateClass({row}) {
      let calss = ''
      switch(row['audit_status']) {
        case '1' :
          calss = 'warning'
        break;
        case '2' :
          calss = 'success'
        break;
        case '3' :
          calss = 'danger'
        break;
        case '5' :
          calss = 'invalid'
        break;
      }
      return calss
    }
  }
}
</script>
<style lang="less" scoped>
.state_icon {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.warning {
  background-color: @color-warning;
}
.success  {
  background-color: @color-success;
}
.danger {
  background-color: @color-danger;
}
.invalid {
  background-color: @color-info;
}
</style>